// extracted by mini-css-extract-plugin
export default {"modal":"KqHN016VQ0WZAtQJ1smJ"};